import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ea-table',
    templateUrl: './ea-table.component.html',
    styleUrls: ['./ea-table.component.scss'],
    standalone: false
})
export class EaTableComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
